<mat-dialog-content>
  <div class="modal">
    <div class="header">
      <span class="error-icon">!</span>
      <span class="header-title">Inconsistency Error</span>
    </div>

    <p class="description">The following inconsistencies have been found within this group:</p>

    <div class="group-name">
      {{ data.isCommodityGroup ? data.commodityGroupName : "Commodity Code " + data.itemNumber }}
    </div>

    <div class="item-list">
      @for (item of allItems; track item.commerceItemNumber) {
        <div class="item-entry">
          <span class="item-label">{{ getItemLabel(item) }}</span>
          @for (detail of getItemDetails(item); track detail) {
            <span class="item-detail">{{ detail }}</span>
          }
        </div>
      }
    </div>

    <div class="resolve-section">
      <p class="resolve-label">TO RESOLVE:</p>
      <p class="resolve-description">
        Select an item from the list below to sync the selected item settings to all items within the group.
      </p>

      <mat-form-field appearance="fill" class="master-select">
        <mat-label>Make a selection</mat-label>
        <mat-select [(ngModel)]="selectedMasterItem">
          @for (item of allItems; track item.commerceItemNumber) {
            <mat-option [value]="item">{{ getItemLabel(item) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="actions">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!selectedMasterItem || !isClickable" (click)="onConfirm()">
        Confirm
      </button>
    </div>
  </div>
</mat-dialog-content>
